import { jsx as _jsx } from "react/jsx-runtime";
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { InformationBanner } from '@common/information-banner/information-banner';
export function AppBuildSettingsError(props) {
    const { children, className } = props;
    return (_jsx(InformationBanner, { variant: "neutral", className: className, ...assignTestId('build-settings-error', props), children: children }));
}
